<template>
  <md-progress-bar v-bind="$attrs" v-on="$listeners">
    <slot></slot>
  </md-progress-bar>
</template>

<script>
export default {
  inheritAttrs: false,
}
</script>

